import React from 'react';

export default function PassThrough({ children }) {
	return typeof children === 'function' ? children() : children;
}
